import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const UnreadIndicator: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-UnreadIndicator" */ '../src/UnreadIndicator.tsx'))
			.UnreadIndicator,
});
